import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { somervilleConfig } from "./data";

export default function SomervilleNJPage() {
  return <CityPageTemplate config={somervilleConfig} />;
}